import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: { id: 'uploadLink.pageTitle', defaultMessage: 'Upload files' },
  askedBy: { id: 'uploadLink.askedBy', defaultMessage: '{assistant} asked you to upload files' },
  yourAssistant: { id: 'uploadLink.yourAssistant', defaultMessage: 'Your AI assistant' },
  yourAssistantNamed: { id: 'uploadLink.yourAssistantNamed', defaultMessage: 'Your AI assistant ({name})' },
  yourAssistantLower: { id: 'uploadLink.yourAssistantLower', defaultMessage: 'your AI assistant' },
  limitFiles: {
    id: 'uploadLink.limitFiles',
    defaultMessage: '{remaining, plural, =0 {No more files} one {# more file} other {Up to # more files}}',
  },
  limitTypes: { id: 'uploadLink.limitTypes', defaultMessage: 'Only {types}' },
  limitCollection: { id: 'uploadLink.limitCollection', defaultMessage: 'Added to a collection' },
  limitExpires: { id: 'uploadLink.limitExpires', defaultMessage: 'Link expires {time}' },
  privacy: {
    id: 'uploadLink.privacy',
    defaultMessage:
      'Files go into your FileSpin account. {assistant} sees their names and status, and can use them like any other asset you have.',
  },
  dropHere: { id: 'uploadLink.dropHere', defaultMessage: 'Drop files or a folder here' },
  dropActive: { id: 'uploadLink.dropActive', defaultMessage: 'Release to upload' },
  or: { id: 'uploadLink.or', defaultMessage: 'or' },
  chooseFiles: { id: 'uploadLink.chooseFiles', defaultMessage: 'Choose files' },
  chooseFolder: { id: 'uploadLink.chooseFolder', defaultMessage: 'Choose a folder' },
  folderNote: { id: 'uploadLink.folderNote', defaultMessage: 'Folder names are kept, so you can search for them later.' },
  statusWaiting: { id: 'uploadLink.statusWaiting', defaultMessage: 'Waiting' },
  statusUploading: { id: 'uploadLink.statusUploading', defaultMessage: 'Uploading {percent}%' },
  statusProcessing: { id: 'uploadLink.statusProcessing', defaultMessage: 'Processing' },
  statusReady: { id: 'uploadLink.statusReady', defaultMessage: 'Ready' },
  statusFailed: { id: 'uploadLink.statusFailed', defaultMessage: 'Failed' },
  retry: { id: 'uploadLink.retry', defaultMessage: 'Retry' },
  remove: { id: 'uploadLink.remove', defaultMessage: 'Remove' },
  rejectedType: { id: 'uploadLink.rejectedType', defaultMessage: '{name}: this link only takes {types}' },
  rejectedFull: {
    id: 'uploadLink.rejectedFull',
    defaultMessage: '{count, plural, one {# file was} other {# files were}} not added: this link takes at most {max} files',
  },
  summary: {
    id: 'uploadLink.summary',
    defaultMessage: '{ready} of {total} ready{failed, plural, =0 {} other {, # failed}}',
  },
  done: { id: 'uploadLink.done', defaultMessage: 'Done' },
  doneHint: {
    id: 'uploadLink.doneHint',
    defaultMessage: 'Press Done when you have added everything. {assistant} picks up from there.',
  },
  doneWaiting: { id: 'uploadLink.doneWaiting', defaultMessage: 'Wait for uploads to finish' },
  closeWithout: { id: 'uploadLink.closeWithout', defaultMessage: 'Close without uploading' },
  closedTitle: { id: 'uploadLink.closedTitle', defaultMessage: 'All set' },
  closedBody: {
    id: 'uploadLink.closedBody',
    defaultMessage:
      '{count, plural, =0 {No files were uploaded.} one {# file is in FileSpin.} other {# files are in FileSpin.}} Go back to {assistant} and tell it you’re done.',
  },
  closedStillProcessing: {
    id: 'uploadLink.closedStillProcessing',
    defaultMessage: 'Some files are still processing. {assistant} can check on them.',
  },
  viewAssets: { id: 'uploadLink.viewAssets', defaultMessage: 'Open FileSpin' },
  alreadyClosedTitle: { id: 'uploadLink.alreadyClosedTitle', defaultMessage: 'This upload link is closed' },
  alreadyClosedBody: {
    id: 'uploadLink.alreadyClosedBody',
    defaultMessage: 'Ask {assistant} for a new link if you have more files.',
  },
  expiredTitle: { id: 'uploadLink.expiredTitle', defaultMessage: 'This upload link has expired' },
  expiredBody: {
    id: 'uploadLink.expiredBody',
    defaultMessage: 'Links last a short while for safety. Ask {assistant} for a new one.',
  },
  notFoundTitle: { id: 'uploadLink.notFoundTitle', defaultMessage: 'We can’t find this upload link' },
  notFoundBody: {
    id: 'uploadLink.notFoundBody',
    defaultMessage:
      'It may belong to another FileSpin account. Sign in with the account you connected to your assistant, or ask it for a new link.',
  },
  loadFailed: { id: 'uploadLink.loadFailed', defaultMessage: 'The upload link didn’t load. Try again in a moment.' },
  tryAgain: { id: 'uploadLink.tryAgain', defaultMessage: 'Try again' },
  closeFailed: { id: 'uploadLink.closeFailed', defaultMessage: 'Couldn’t close the link. Try again.' },
  leaveWarning: { id: 'uploadLink.leaveWarning', defaultMessage: 'Uploads are still running. Leave anyway?' },
});
